import steps from '../../survey/steps';

export function initOneTrustTracking(): void {
  const acceptHandler = (e: Event): void => {
    const target = e.target as HTMLElement | null;
    if (
      target?.id === 'onetrust-accept-btn-handler'
      || target?.id === 'accept-recommended-btn-handler'
    ) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_accept',
        },
      });
    }
  };

  const settingsHandler = (e: Event): void => {
    const target = e.target as HTMLElement | null;
    if (
      target?.id === 'onetrust-pc-btn-handler'
      || target?.classList?.contains('ot-floating-button__open')
    ) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_settings',
        },
      });
    }
  };

  const rejectHandler = (e: Event): void => {
    const target = e.target as HTMLElement | null;
    if (target?.classList?.contains('ot-pc-refuse-all-handler')) {
      steps.analytics.send({
        event: {
          event: 'quiz_funnel',
          quiz_action: 'onetrust_reject',
        },
      });
    }
  };

  window.addEventListener('OneTrustGroupsUpdated', () => {
    const groups = window.OnetrustActiveGroups || '';

    steps.analytics.send({
      event: {
        event: 'quiz_funnel',
        quiz_action: 'onetrust_preferences',
        quiz_answer: groups,
      },
    });
  });

  document.addEventListener('click', (e) => {
    acceptHandler(e);
    settingsHandler(e);
    rejectHandler(e);
  });
}
